import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Router,RouterLink,RouterLinkActive,RouterOutlet  } from '@angular/router';

@Component({
  selector: 'admin-layout',
  standalone: true,
  imports: [RouterOutlet,  CommonModule,
    RouterLink,
    RouterLinkActive,
    MatIconModule,
    ],
  templateUrl: './admin-layout.component.html',
  styleUrl: './admin-layout.component.scss'
})
export class AdminLayoutComponent {
 isSidebarCollapsed = false;

  constructor(private router: Router) {}

  toggleSidebar(): void {
    this.isSidebarCollapsed = !this.isSidebarCollapsed;
  }

  logout(): void {
    localStorage.removeItem('isLoggedIn');
    this.router.navigate(['/login']);
  }

  navigateToVisualizer(): void {
    this.router.navigate(['/visualizer']);
  }
}
